<template>
  <div class="search-jobs-wrapper section_inner">
    <v-layout :class="'norm'">
      <v-flex class="search-edit-icon">
        <v-icon
          class="icon-shape-1-6 pointer display-33 search-edit-icon--icon"
          @click="toggleEdit"
        />
      </v-flex>

      <v-flex class="resultsMain_search pr-0" col-sm-12>
        <div id="search-wrap" class="search-wrap">
          <v-layout
            wrap
            class="resultsMain_search_label resultsMain_search_label_main"
          >
            <v-flex>
              <p class="black--text text-right display-22 pr-1 mb-0">
                {{ SearchParams.SearchTitle }}
              </p>
            </v-flex>
          </v-layout>

          <v-layout wrap :class="layoutClass" class="layout-c">
            <SearchManager
              :is-no-cv-page="isNoCvPage"
              :filters="filters"
              :search-properties="searchProperties"
              :showFilters="true"
              id="SearchManager"
              :isSticky="isSticky"
              :isIndex="false"
              :is-loading="isLoading"
            />
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SearchParams from '@/lib/enums/SearchParams';
import SearchManager from '@/components/JobsSearch/SearchManager';

export default {
  components: {
    SearchManager,
  },
  props: {
    isNoCvPage: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSticky: {
      type: Boolean,
      required: true,
      default: false,
    },
    filters: {
      type: Object,
      required: false,
      default: () => {},
    },
    searchProperties: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      SearchParams: SearchParams,
      isEditing: false,
    };
  },

  computed: {
    layoutClass() {
      const { isSticky, isEditing } = this;
      return {
        'norm-layout': isSticky,
        'sticky-layout': !isSticky,
        'is-editing': isEditing,
      };
    },
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onPageScroll);
    window.removeEventListener('resize', this.onResize);
  },

  mounted() {
    window.addEventListener('scroll', this.onPageScroll);
    // We listen to the resize event for filters popup height
    // Then we set the value in the --vh custom property to the root of the document
    window.addEventListener('resize', this.onResize);

    this.setHeight();
  },

  methods: {
    /**
     * set the height of the popup filters on mobile , reduce the navgiation and bottom bar height
     */
    setHeight() {
      const vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },

    onPageScroll() {
      this.isEditing = false;
    },

    onResize() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },

    toggleEdit() {
      window.scrollTo(0, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.spacer {
  flex-grow: 0.1 !important;
}

div.focus {
  border: 1px solid #bdbdbd;
}

.v-list__tile.focus {
  border: 1px solid #bdbdbd;
}

button.focus {
  border: 1px solid #bdbdbd;
}

.search-wrap {
  position: relative;
}

.search-res {
  height: 258px;
  object-fit: contain;
  border-radius: 39.5px;
  border: solid 1px #d7d7d7;
  background-color: white;
  position: absolute;
  width: 100%;
  z-index: 10;
}

.my-scrollbar {
  width: 90%;
  max-height: 200px;
}

.search-edit-icon {
  display: none;
}

.search-input-wrap {
  padding: 2px;
  font-size: 16px;
  border-radius: 50px;
  background-color: #fff;
  border: 0px;
  margin: 0px;
  box-shadow: 0px 0px 5px #999;
}

.search-jobs-wrapper.sticky {
  max-width: initial;
  width: 100%;
  margin: 0 auto;
  padding-top: 0;
}

h3.search-jobs-title {
  font-size: 22px;
  font-weight: normal;
  color: #000;
}

.input-top-text {
  position: absolute;
  top: -35px;
  width: 100%;
}

.cat_btn {
  width: 95%;
  height: auto;
}

.sticky-filter {
  display: flex;
  justify-content: flex-start;
  position: relative;
}

.norm-layout {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

/* results main */
.centeredContent {
  max-width: 1280px;
  width: 100%;
  margin: 0px auto;
  padding: 0px 15px;
}

.resultsMain {
  position: relative;
  margin-top: 12px;
}

.resultsMain .resultsMain_content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.resultsMain .resultsMain_content .centeredContent {
  padding: 0;
}

.resultsMain .resultsMain_image {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.resultsMain .resultsMain_image img {
  display: block;
}

.resultsMain .resultsMain_content h1 {
  font-size: 22px;
  font-weight: normal;
  margin: 69px 0 12px;
}

.flex,
.child-flex > * {
  max-width: unset;
}

.resultsMain_search.searchSticky {
  max-width: 1297px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 35px 0 33px;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffffff;
  z-index: 9;
}

.resultsMain_searchCategories {
  flex: 1 1 0;
  max-width: none;
  margin: 0 2px;
}
#jobs-page-search .v-menu {
  display: block !important;
}
.sticky-layout .resultsMain_search .resultsMain_search_search-input-wrap {
  flex-wrap: initial;
}
@media screen and (max-width: 1500px) {
}

@media screen and (max-width: 1024px) {
  .sticky-layout .resultsMain_search {
    max-width: 590px;
  }
  .sticky-layout {
    padding: 4px 5px;
  }

  .sticky-layout .resultsMain_search {
    max-width: 100%;
    font-size: 16px;
  }
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 768px) {
  .resultsMain_search {
    box-shadow: none;
  }

  #jobs-page-search .try input {
    font-size: 16px !important;
  }

  h3 {
    font-size: 16px;
    margin: 10px 0 12px;
  }

  .norm-layout {
    flex-direction: column;
    padding: 5px;
    align-items: normal;
  }
}

@media screen and (max-width: 600px) {
  ::-webkit-scrollbar {
    display: none;
  }
  .sticky-layout {
    flex-direction: column;
  }

  .sticky-layout:not(.is-editing) {
    // hide search input icons
    [class~='v-input__append-inner'] {
      display: none;
    }

    .search-input input {
      text-overflow: ellipsis;
    }
  }

  .search-filter .search-filter-wrapper {
    align-items: flex-end;
    overflow: auto;
  }
  // change width of content when switching to and from sticky mode
  .sticky-layout .resultsMain_search .resultsMain_search_search-input-wrap {
    .v-menu {
      position: fixed;
    }
    .menu-props-class {
      min-width: auto !important;
    }
  }
  .search-jobs-wrapper {
    margin: 10px auto 0;
  }

  .search-jobs-wrapper.sticky {
    background-color: $bg-gray;
  }

  .sticky-layout {
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;

    .spacer {
      width: 10px;
    }

    .search-edit-icon {
      display: block;
      background-color: $white;
      padding: 7px 10px;
      margin-left: 5px;
      border-radius: 8px;
      height: 38px;
      margin-top: 5px;
    }

    .search-filter {
      padding: 0 10px;
      display: flex;
    }

    .search-filter .search-filter-wrapper {
      align-items: flex-end;
      overflow: unset;
    }

    .search-input-wrap {
      padding: 0;
      height: 35px;
      margin: 0 !important;
    }

    .resultsMain_search_label {
      display: none;
    }
  }

  .resultsMain_search {
    margin: 0;
    padding: 0;
    min-width: 200px;
  }

  .search-filter {
    align-self: auto;
    flex-basis: 0;
  }

  .sticky-layout .search-filter {
    align-self: auto;
    margin-top: 0;
    width: 100%;
    flex-basis: 0;
  }

  .norm-layout {
    flex-direction: column;
  }

  .sticky-layout #SearchManager #sticky-wrapper {
    flex-wrap: nowrap;
  }
}

@media screen and (max-width: 400px) {
  .search-filter {
    flex-basis: 0;
  }
  .resultsMain_search_label {
    margin-top: 10px;
  }
}

.resultsMain_search .resultsMain_search-wrap {
  width: 100%;
}

// change width of content when switching to and from sticky mode
.resultsMain_search .resultsMain_search_search-input-wrap {
  .v-menu {
    position: absolute;
    z-index: 10;
    left: 0;
    right: 0;
    top: 0;
  }

  .menu-props-class {
    left: 0;
    right: 0;
  }

  .sticky-layout & {
    .menu-props-class {
      min-width: auto !important;
    }
  }
}
</style>
